import axios from 'axios';
import { call, put } from 'redux-saga/effects';
import api from './auth';

export const checkResponseData = (response) => {
  if (axios.isCancel(response)) {
    const error = new Error('Request Cancelled');
    error.cancelled = true;
    throw error;
  }
  if (response instanceof Error) {
    const ex = response;
    if (ex.response) {
      const msg = ex.response.data?.errors?.[0]
        || ex.response.data?.description
        || ex.response.data?.message
        || 'Request failed';
      const error = new Error(msg);
      error.response = ex.response;
      throw error;
    }
    throw ex;
  }
  if (typeof response.data !== 'object') {
    const error = new Error('Invalid response');
    error.response = response;
    throw error;
  }
  if (response.data.errors?.length) {
    const error = new Error(response.data.errors[0]);
    error.response = response;
    throw error;
  }
  return response.data;
};

export const sagaApiRequest = async (axiosPromise) =>
  await axiosPromise.then(checkResponseData).catch(checkResponseData);

export const standardRequest = ({
  action,
  requestOptions,
  requestOptionsFromPayload,
  dataPath = 'entity',
  dataDefault = null,
}) =>
  function* ({ payload = {} }) {
    const { successCb, errorCb, ...rest } = payload;
    let data;
    try {
      const opts = requestOptionsFromPayload
        ? requestOptionsFromPayload(rest)
        : requestOptions;
      const response = yield call(sagaApiRequest, api(opts));
      data = dataPath ? response[dataPath] : response;
      if (data === undefined) data = dataDefault;
      yield put(action.successAction(data));
      if (successCb) successCb(data);
    } catch (error) {
      yield put(action.errorAction(error));
      if (errorCb) errorCb(error);
    }
    return data;
  };

export const formatAreaSqm = (sqm, options = {}) => {
  if (sqm == null || Number.isNaN(sqm)) return '—';
  const n = Number(sqm);
  const alwaysSqm = options.alwaysSqm === true;
  if (alwaysSqm || n < 10000) return `${Math.round(n).toLocaleString()} m²`;
  return `${(n / 10000).toFixed(2)} ha`;
};
